import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import { initDeployRefresh } from './utils/deployRefresh';

initDeployRefresh();

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
